import { z } from 'zod'

/**
 * The Rails API wraps every single-resource response in a singular key —
 * `{ article: {...} }`, `{ tenant: {...} }`, `{ generation: {...} }`, … .
 * `envelope(key, inner)` parses that wrapper and yields the INNER value, so
 * callers keep working with the resource type directly. Lists keep their own
 * `{ <plural>: [], meta }` shape via `listSchema` from `@cockpit/api-contract`.
 */
export function envelope<K extends string, T extends z.ZodTypeAny>(key: K, inner: T) {
  const shape = { [key]: inner } as { [P in K]: T }
  return z.object(shape).transform((parsed) => (parsed as Record<K, z.infer<T>>)[key])
}
